import React, { useState } from 'react';
import { FormHelperText, InputAdornment, SxProps, TextField } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import CalendarIcon from 'app/components/Icons/CalendarIcon';
import { useTranslation } from 'react-i18next';

interface DateInputProps {
  selectedDate: Dayjs | string | null;
  onDateChange: (date: Dayjs | null) => void;
  setDate?: (date: Dayjs | null) => void;
  minDate?: Dayjs | null;
  maxDate?: Dayjs | null;
  label?: string;
  placeholder?: string;
  errorText?: string;
  hasError?: boolean;
  register?: any;
  sx?: SxProps;
  isError? : boolean;
  isWithoutCustomError? : boolean;
  formatDate?: "DD/MM/YYYY" | "YYYY/MM/DD" | "MM/DD/YYYY" | "YYYY-MM-DD";
  mask?: string;
  // color?: 'secondary';
}

const DateInput: React.FC<DateInputProps> = ({
  minDate,
  maxDate,
  onDateChange,
  label,
  placeholder,
  selectedDate,
  register,
  isError,
  errorText,
  isWithoutCustomError = false,
  formatDate = "DD/MM/YYYY",
  sx,
}) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [dateError, setDateError] = useState(false);
  const handleDateChange = (newValue: Dayjs | null) => {
    onDateChange(newValue);
  };
  const handleFocus = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleAccept = () => {
    setIsOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        minDate={minDate}
        maxDate={maxDate}
        label={label || 'Test'}
        inputFormat={formatDate}
        value={selectedDate ?? ''}
        onChange={handleDateChange}
        open={isOpen}
        onClose={handleClose}
        onAccept={handleAccept}
        autoFocus={isOpen}
        renderInput={(params) => (
          <TextField
            {...params}
            onClick={handleFocus}
            label={null}
            error={dateError}
            helperText={
              !isWithoutCustomError && (!dayjs(selectedDate).isValid() && selectedDate
                ? t('commonActions.dateformatError')
                : dayjs(selectedDate).isAfter(dayjs())
                  ? t('commonActions.futureDateError')
                  : '')
            }
            placeholder={placeholder}
            inputMode={'text'}
            inputProps={{
              ...params.inputProps,
              placeholder,
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <CalendarIcon sx={{ fill: 'transparent' }} />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiInputAdornment-positionEnd': {
                display: 'none',
              },
              '& .MuiInputAdornment-positionStart': {
                marginRight: '0px !important',
              },
              '& .MuiOutlinedInput-root': {
                '& input': {
                  paddingRight: '0px',
                  paddingLeft : "8px",
                  width: '100%',
                },
              },
              ...sx
            }}
            {...register}
          />
        )}
      />
      {isError && <FormHelperText sx={{color : "red"}}>{errorText}</FormHelperText>}
    </LocalizationProvider>
  );
};

export default DateInput;
